import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { baseUrl } from '../config';
import SEO from '../components/SEO';



const ApplyProjects = () => {
  // Mock project data
  const [projects] = useState([
    { id: 1, title: 'Feature Film Project', description: 'A full-length feature film project.', status: 'Open', location: 'Los Angeles', role: 'Actor' },
    { id: 2, title: 'Short Film Project', description: 'A short film about friendship.', status: 'Open', location: 'New York', role: 'Director' },
    { id: 3, title: 'Commercial Ad', description: 'A commercial ad for a new product.', status: 'Closed', location: 'Chicago', role: 'Cameraman' },
    { id: 4, title: 'Documentary', description: 'A documentary exploring climate change.', status: 'Open', location: 'Miami', role: 'Producer' },
  ]);

  // State to handle the current project being applied to
  const [selectedProject, setSelectedProject] = useState(null);
  const navigate = useNavigate();

  // Handler to select a project
  const handleApply = (project) => {
    setSelectedProject(project);
    navigate('/careers');
  };

  // Handler to submit the application form
  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`You have applied for the project: ${selectedProject.title}`);
    setSelectedProject(null);  // Reset after applying
  };

  return (
    <>
    <SEO
      title="Apply to Film Projects"
      description="Browse and apply to open film production projects on ProducerBuddy. Find your next role in film today."
      url="https://producerbuddy.pilomation.com/apply-projects"
      robots="noindex, nofollow"
    />
    <div className='flex gap-3'>
    {/* Sidebar */}
    {/* <div className="w-64 bg-gray-800 text-white p-5 space-y-6">
      <h1 className="text-2xl font-bold"><Link to='/film-enthusiast'>Film Dashboard</Link></h1>
      <nav>
        <ul className="space-y-4 mt-4">
          <li className="hover:text-yellow-400">
            <Link to="/myprojects">My Projects</Link>
          </li>
          <li className="hover:text-yellow-400">
          <Link to="/services">Tools</Link>
        </li>
        <li className="hover:text-yellow-400">
          <Link to="/enthusiast-schedule">My Schedules</Link>
        </li>
        <li className="hover:text-yellow-400">
          <Link to="/applyprojects">Apply to Projects</Link>
        </li>
      </ul>
    </nav>
  </div> */}
    <div className="apply-projects bg-gray-100 p-6 rounded shadow-md w-full">
      <h2 className="text-2xl font-bold mb-4">Apply to Projects</h2>

      {/* Projects List */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {projects.map((project) => (
          <div key={project.id} className="bg-white p-4 rounded shadow">
            <h3 className="text-xl font-bold">{project.title}</h3>
            <p>{project.description}</p>
            <p className="text-gray-500">Location: {project.location}</p>
            <p className="text-gray-500">Role: {project.role}</p>
            <p className={`mt-2 ${project.status === 'Open' ? 'text-green-500' : 'text-red-500'}`}>{project.status}</p>
            <button
              onClick={() => handleApply(project)}
              disabled={project.status !== 'Open'}
              className={` px-4 py-2 rounded ${project.status === 'Open' ? 'bg-yellow-400 text-black' : 'bg-gray-400 text-gray-700 cursor-not-allowed'}`}
            >
              {project.status === 'Open' ? 'Apply' : 'Closed'}
            </button>
          </div>
        ))}
      </div>

      {/* Application Form 
      {selectedProject && (
        <div className="apply-form bg-white p-6 mt-6 rounded shadow">
          <h3 className="text-xl font-bold">Apply to {selectedProject.title}</h3>
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-gray-700">Your Name:</label>
              <input
                type="text"
                required
                className="mt-1 block w-full border border-gray-300 rounded py-2 px-4"
                placeholder="Enter your name"
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700">Email:</label>
              <input
                type="email"
                required
                className="mt-1 block w-full border border-gray-300 rounded py-2 px-4"
                placeholder="Enter your email"
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700">Why are you a good fit for this role?</label>
              <textarea
                required
                className="mt-1 block w-full border border-gray-300 rounded py-2 px-4"
                rows="4"
                placeholder="Describe your experience"
              ></textarea>
            </div>
            <div className="flex space-x-4">
              <button type="submit" className="bg-yellow-400 text-black px-4 py-2 rounded">Submit Application</button>
              <button onClick={() => setSelectedProject(null)} className="bg-red-400 text-white px-4 py-2 rounded">Cancel</button>
            </div>
          </form>
        </div>
      )}*/}
    </div>
    </div>
   
    </>
    
  );
};

export default ApplyProjects;

